import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import OuterLayout from "../layout/OuterLayout/OuterLayout";
import Dashboard from "../pages/dashboard/index";
import LoginContentSection from "../pages/auth/components/login/LoginContentSection";
import ForgotContentSection from "../pages/auth/components/forgot-password/ForgotContentSection";
import ResetContentSection from "../pages/auth/components/reset-password/ResetContentSection";
import PublicRoute from "./PublicRoute";
import ProtectedRoute from "./ProtectedRoute";
import ProfileSettings from "../pages/profile-settings";
import OtpVerifyContentSection from "../pages/auth/components/otpVerification/OtpVerifyContentSection";
import ScheduleCalendar from "../pages/ScheduleCalendar/ScheduleCalendar";
import Sessions from "../pages/sessions";
import MiniCourses from "../pages/playbook-mini-courses";
import Certificates from "../pages/certificates";
import Chat from "../pages/chat";
import GeneralDiscussion from "../pages/general-discussion";
import InnerLayout from "../layout/InnerLayout";
import AllProjects from "../pages/projects/components/AllProjects";
import MyProjects from "../pages/projects/components/MyProjects";

import RecordedSession from "../pages/recorded-session";
import DownloadApp from "../pages/download-app/DownloadApp";
import { ROUTES } from "../constants";
import ShowProjectsDetails from "../pages/projects/components/ShowProjectsDetails";
import ReportsPage from "../pages/reports";
import SpecialEvent from "../pages/special-events";
import Notification from "../pages/notifications/Notification";
import { useSelector } from "react-redux";
import Programs from "../pages/programs";
import LessonDetails from "../pages/lessons/components/LessonDetails";
import MasterClassDetails from "../pages/master-classes/components/MasterClassDetails";
import ProgramDetails from "../pages/programs/components/ProgramDetails";
import MasterClasses from "../pages/master-classes";
import LiveEvent from "../pages/live-events";
import Community from "../pages/community";
import MasterClassDiscussionDetails from "../pages/community/components/MasterClassDiscussionDetails";
import MasterClassDiscussions from "../pages/community/components/MasterClassDiscussions";
import CommunityQuestions from "../pages/community/components/CommunityQuestions";
import CommunityQuestionDetails from "../pages/community/components/CommunityQuestionDetails";
import UserProfile from "../pages/users/UserProfile";
import UsersOnline from "../pages/users/UsersOnline";
import MemberDiscussions from "../pages/community/components/MemberDiscussions";
import MemberDiscussionDetails from "../pages/community/components/MemberDiscussionDetails";
import CommentDetails from "../pages/community/components/CommentDetails";
import PreviewProgram from "../pages/programs/components/PreviewProgram";
import PreviewMasterClass from "../pages/master-classes/components/PreviewMasterClass";
import ProgramCertificate from "../pages/programs/components/ProgramCertificate";
import MasterClassCertificate from "../pages/master-classes/components/MasterClassCertificate";
import ProfileAchievements from "../pages/profile-settings/Components/ProfileAchievements";
import Playlists from "../pages/playlists";
import PlaylistDetails from "../pages/playlists/components/PlaylistDetails";
import LoginCallbackSection from "../pages/auth/components/login/LoginCallbackSection";

const AppRoutes = () => {
    const [isPreviousSession, setIsPreviousSession] = useState(false);
    const token = useSelector((state) => state?.auth?.accessToken);

    return (
        <Routes>
            {/* Auth routes start */}
            <Route path="/" element={<OuterLayout />}>
                <Route
                    path="/"
                    element={
                        <PublicRoute>
                            <LoginContentSection />
                        </PublicRoute>
                    }
                />
                <Route
                    path="login/processing"
                    element={
                        <PublicRoute>
                            <LoginCallbackSection />
                        </PublicRoute>
                    }
                />
                <Route
                    path="forgot-password"
                    element={
                        <PublicRoute>
                            <ForgotContentSection />
                        </PublicRoute>
                    }
                />
                <Route
                    path="verify-otp"
                    element={
                        <PublicRoute>
                            <OtpVerifyContentSection />
                        </PublicRoute>
                    }
                />
                <Route
                    path="reset-password"
                    element={
                        <PublicRoute>
                            <ResetContentSection />
                        </PublicRoute>
                    }
                />
                {token === null && (
                    <>
                        <Route
                            path="dashboard/live-event/:id"
                            element={
                                <PublicRoute>
                                    <LoginContentSection />
                                </PublicRoute>
                            }
                        />
                        <Route
                            path="dashboard/coaching-call/:id"
                            element={
                                <PublicRoute>
                                    <LoginContentSection />
                                </PublicRoute>
                            }
                        />
                        <Route
                            path="dashboard/masterclass-discussion/:id"
                            element={
                                <PublicRoute>
                                    <LoginContentSection />
                                </PublicRoute>
                            }
                        />
                        <Route
                            path="dashboard/session/:id"
                            element={
                                <PublicRoute>
                                    <LoginContentSection />
                                </PublicRoute>
                            }
                        />
                    </>
                )}
            </Route>
            {/* Auth routes end */}

            {/* Inner routes start */}
            <Route path="" element={<InnerLayout />}>
                <Route
                    path={ROUTES.dashboard}
                    element={
                        <ProtectedRoute>
                            <Dashboard setIsPreviousSession={setIsPreviousSession} isPreviousSession={isPreviousSession} />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={ROUTES.meetingPage}
                    element={
                        <ProtectedRoute>
                            <Dashboard setIsPreviousSession={setIsPreviousSession} isPreviousSession={isPreviousSession} />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="profile-settings"
                    element={
                        <ProtectedRoute>
                            <ProfileSettings />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="profile-settings/achievements"
                    element={
                        <ProtectedRoute>
                            <ProfileAchievements />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="calendar"
                    element={
                        <ProtectedRoute>
                            <ScheduleCalendar />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="keynotes"
                    element={
                        <ProtectedRoute>
                            <Sessions setIsPreviousSession={setIsPreviousSession} />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="community/general-discussion"
                    element={
                        <ProtectedRoute>
                            <GeneralDiscussion />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="community"
                    element={
                        <ProtectedRoute>
                            <Community />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="community/questions-for-the-community"
                    element={
                        <ProtectedRoute>
                            <CommunityQuestions />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="community/questions-for-the-community/:id"
                    element={
                        <ProtectedRoute>
                            <CommunityQuestionDetails />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="community/member-discussions"
                    element={
                        <ProtectedRoute>
                            <MemberDiscussions />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="community/member-discussions/:id"
                    element={
                        <ProtectedRoute>
                            <MemberDiscussionDetails />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="comments/:id"
                    element={
                        <ProtectedRoute>
                            <CommentDetails />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="impacts/my-impacts"
                    element={
                        <ProtectedRoute>
                            <MyProjects />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="impacts/all-impacts"
                    element={
                        <ProtectedRoute>
                            <AllProjects />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="impacts/my-impacts/:impactId"
                    element={
                        <ProtectedRoute>
                            <ShowProjectsDetails />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="impacts/all-impacts/:impactId"
                    element={
                        <ProtectedRoute>
                            <ShowProjectsDetails />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="certificate"
                    element={
                        <ProtectedRoute>
                            <Certificates />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="technical-assistant"
                    element={
                        <ProtectedRoute>
                            <Chat />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="playbook"
                    element={
                        <ProtectedRoute>
                            <MiniCourses />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="recorded-sessions"
                    element={
                        <ProtectedRoute>
                            <RecordedSession />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="download-app"
                    element={
                        <ProtectedRoute>
                            <DownloadApp />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="reports"
                    element={
                        <ProtectedRoute>
                            <ReportsPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="live-events"
                    element={
                        <ProtectedRoute>
                            <SpecialEvent />
                        </ProtectedRoute>
                    }
                />
                />
                <Route
                    path="live-events/:id"
                    element={
                        <ProtectedRoute>
                            <LiveEvent />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="notification"
                    element={
                        <ProtectedRoute>
                            <Notification />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="programs"
                    element={
                        <ProtectedRoute>
                            <Programs />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="programs/:id"
                    element={
                        <ProtectedRoute>
                            <ProgramDetails />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="programs/:id/preview"
                    element={
                        <ProtectedRoute>
                            <PreviewProgram />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="master-classes"
                    element={
                        <ProtectedRoute>
                            <MasterClasses />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="master-classes/:id"
                    element={
                        <ProtectedRoute>
                            <MasterClassDetails />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="master-classes/:id/preview"
                    element={
                        <ProtectedRoute>
                            <PreviewMasterClass />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="master-class/discussions"
                    element={
                        <ProtectedRoute>
                            <MasterClassDiscussions />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="master-class/discussions/:id"
                    element={
                        <ProtectedRoute>
                            <MasterClassDiscussionDetails />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="lessons/:id"
                    element={
                        <ProtectedRoute>
                            <LessonDetails />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="community/users-online"
                    element={
                        <ProtectedRoute>
                            <UsersOnline />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="community/users/:id"
                    element={
                        <ProtectedRoute>
                            <UserProfile />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="programs/certificates/:id"
                    element={
                        <ProtectedRoute>
                            <ProgramCertificate />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="master-classes/certificates/:id"
                    element={
                        <ProtectedRoute>
                            <MasterClassCertificate />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="playlists"
                    element={
                        <ProtectedRoute>
                            <Playlists />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="playlists/:id"
                    element={
                        <ProtectedRoute>
                            <PlaylistDetails />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="playlists/favorites"
                    element={
                        <ProtectedRoute>
                            <PlaylistDetails isFavorites={true} />
                        </ProtectedRoute>
                    }
                />
            </Route>
            {/* Inner routes end */}
        </Routes>
    );
};

export default AppRoutes;
